export class UserData {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
